<!--
 功能名称:千里眼平台(技师)-业绩
 开发人:梁高权
 创建时间:2021/03/30
 最后修改时间:2021/03/30
-->
<template>
  <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <div class="achievement-wrap">
      <div class="panel">
        <!-- 当前门店 -->
        <div class="panel-shop">
          <div class="panel-shop-left">
            <img :src="userStatus.head_img">
            <div>
              <h5>{{shopNameTitle|stringFormat}}</h5>
              <span>{{userStatus.nickname|stringFormat}}</span>
            </div>
          </div>
          <div class="panel-shop-right" @click="$router.push('store-message')">
            <span>切换门店</span>
            <van-icon name="arrow"  size="18" />
          </div>
        </div>

        <!-- 总提成 -->
        <div class="total_money">
          <h5>总提成 (元)</h5>
          <h4>{{pushMoney.total_money|valueKbit}}</h4>
        </div>

        <!-- 提成组 -->
        <ul class="pushMoney_type">
          <li>
            <h5>业绩提成&nbsp;(元)</h5>
            <span>{{pushMoney.service_money|valueKbit}}</span>
          </li>
          <li>
            <h5>推销提成&nbsp;(元)</h5>
            <span>{{pushMoney.sell_money|valueKbit}}</span>
          </li>
          <li>
            <h5>售卡提成&nbsp;(元)</h5>
            <span>{{pushMoney.sell_card_money|valueKbit}}</span>
          </li>
        </ul>

        <!-- 同步时间 -->
        <div class="synchronize_time">
          <img src="@/assets/images/renewal.png">
          <span>数据同步时间：{{pushMoney.synchronize_time}}</span>
        </div>

        <!-- 提成点数 -->
        <div class="pushMoneyDot">
          <div class="pushMoneyDot-title">
            <div class="left">
              <div :class="['Gbutton',query_type===1?'Blue':'']" @click="query_type=1">按日</div>
              <div :class="['Gbutton',query_type===2?'Blue':'']" @click="query_type=2">按月</div>
            </div>
            <div class="right Gbutton" @click="$router.push('achievementDetail')">业绩详情</div>
          </div>
          <ul>
            <li>
              <h5>总点</h5>
              <span>{{pushMoney.total_clock}}</span>
            </li>
            <li>
              <h5>点钟</h5>
              <span>{{pushMoney.doc_clock}}</span>
            </li>
            <li>
              <h5>加钟</h5>
              <span>{{pushMoney.add_clock}}</span>
            </li>
            <li>
              <h5>Call钟</h5>
              <span>{{pushMoney.call_clock}}</span>
            </li>
          </ul>
        </div>

      </div>
    </div>
    <drag :date="date" :motto="motto"/>
    <activity ref="activity"/>
  </van-pull-refresh>

</template>

<script>
import table from '@/api/table'
import { mapState} from 'vuex'
import drag from '@/components/drag.vue'
import activity from './components/activity.vue'
export default {
  name: 'achievement',
  components: {
    drag,
    activity
  },
  filters: {
    // 格式化日期
    dateFormat(val){
      return (val||'').substring(0,4)+'年'+(val||'').substring(5,7)+'月'+(val||'').substring(8,10)+'日'
    }
  },
  mixins: [],
  props: {},
  data () {
    return {
      isLoading: false,
      motto:null,
      date:null,
      shopNameTitle:localStorage.getItem('shopNameTitle'),
      query_type:1,
      pushMoney:new Object(),
      openidDdta:[
        'ol0y_uGrplXFaHZHE5n8MLcpp_ck',
        'ol0y_uNOETeezYwICx7pS7sYBfLM',
        'ol0y_uFxOvVcaolKH4om43wWl2Ro',
        'ol0y_uK-0qT7VO4RfCfdFL8qqmzQ',
        'ol0y_uDz998RBe_zc9FbdgZXG584',
        'ol0y_uAG8F0dISpUrMbKBTkXnfSM',
        'ol0y_uHgDAWufvCyL6k14rOkRRPo',
        'ol0y_uAlXi5vYihMjG3HkKkhUkVk',
        'ol0y_uEKh9Lp5k9AT5Rq-SM1tmNY',
        'ol0y_uJLmDZo23_O56Uy48acw3I8',
        'ol0y_uBejW9SQ_o5o7cXoYQbnr2Q',
        'ol0y_uC5GC1JoQvScvMSBMpCYHdM',
        'ol0y_uIG9sS6mtBCAQ3ESjfFUGeQ',
        'ol0y_uCUOHX4mStcRrz1vImEqL5I',
        'ol0y_uEfn38jlPFajhagpKGGzow4'
      ]
    }
  },
  filters:{
    // 格式化字符
    stringFormat(val){
      let a='';if(val.length>10){a=val.substring(0,10)+'...'}else{a=val}
      return a
    },
  },
  computed: {...mapState(['userStatus','openid'])},
  watch: {
    query_type() {this.achievementIndex()}
  },
  created () {
    this.achievementIndex();
    table.getMotto().then(response=>{
      this.motto=response.data.motto;
      this.date=response.data.date;
    })
  },
  mounted () {
    console.log()
    // if(this.openid==='ol0y_uNOETeezYwICx7pS7sYBfLM'||this.openid==='ol0y_uGrplXFaHZHE5n8MLcpp_ck'){
      // this.$refs.activity.open()
    // }
  },
  methods: {
    // 下拉刷新
    onRefresh(){
      this.achievementIndex()
    },
    // 业绩首页提成
    achievementIndex(){
      table.achievementIndex({query_type:this.query_type}).then(response=>{
        if(response.data.lottery){
            this.$refs.activity.open()
          // let bool=false
          // this.openidDdta.forEach(openid=>{
          //   if(this.openid==openid){bool=true}
          // })
          // if(bool){this.$refs.activity.open()}
        }
        // console.log(response.data.lottery)
        this.pushMoney=response.data
        this.$store.commit('updateSynchronizeTime',response.data.synchronize_time)
        this.isLoading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .van-pull-refresh__track{
    min-height: calc(100vh - 100px);
    position: relative;
  }
  .achievement-wrap {
    .panel{
      height: 773px;
      padding: 0 30px;
      color: #fff;
      background: url("~@/assets/images/achievement-Bg.png") no-repeat center/100% 100%;
      &-shop{
        position: relative;
        height: 140px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &-left{
          display: flex;
          img{
            width: 66px;
            height: 66px;
            border-radius: 50%;
            border: 2px solid #fff;
            margin-right: 20px
          }
          div{
            h5{
              color:rgba(255,255,255,.5);
              margin-bottom: 10px;
              line-height: 28px;
              font-size: 28px
            }
            span{
              font-weight: bold;
              font-size: 30px
            }
          }
        }
        &-right{
          display: flex;
          align-items: center;
          span{
            white-space:nowrap;
            font-size: 30px;font-weight:500
          }
        }
      }
      &-shop::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 0;
          bottom: 0;
          left: 0;
          border-bottom: 2px solid rgba(245,245,245,.2);
          transform: scaleY(.5)
      }
      // 总提成
      .total_money{
        margin:42px auto 35px;
        h5{
          text-align: center;
          font-size: 28px;
          font-weight: 500;
        }
        h4{
          text-align: center;
          font-size: 100px;
        }
      }
      // 提成组
      .pushMoney_type{
        display: flex;
        justify-content: space-around;
        li{
          display: flex;
          flex-direction: column;
          align-items: center;
          h5{
            font-size: 22px;
            font-weight: 500;
            margin-bottom: 5px;
          }
          span{
            font-size: 40px;
            font-weight: 500;
          }
        }
      }
      // 同步时间
      .synchronize_time{
        color: rgba(255,255,255,.5);
        font-size: 22px;
        margin-top: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
        img{width: 30px;height: 26px;margin-right: 18px}
      }
      // 提成点数
      .pushMoneyDot{
        margin-top: 30px;
        background: #fff;
        box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.05);
        border-radius: 16px;
        padding: 45px 30px 50px;
        &-title{
          display: flex;
          justify-content: space-between;
          color: #0A60D9;
          .left{
            display: flex;
            div:nth-child(1){margin-right: 14px;}
            .Blue{
              background:#0A60D9 ;
              color: #fff;
            }
          }
          .Gbutton{
            background: #E2EBFD;
            font-size: 28px;
            padding: 7px 22px;
            border-radius: 5px;
          }
        }
        ul{
          color: #333;
          display: flex;
          justify-content: space-between;
          li{
            margin-top: 40px;
            display: flex;
            flex-direction: column;
            align-items: center;
            h5{
              color: #999;
              font-size: 26px;
            }
            span{
              font-size: 38px;
            }
          }
        }
      }
    }
  }
  .steward{
    position: absolute;
    bottom: 20px;
    background: #F0F4FA;
    border: 1px solid #D5DBE4;
    box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    display: flex;
    padding: 50px 35px;
    width: 690px;
    left: 50%;
    transform: translateX(-50%);
    padding-right: 125px;
    div{
      h4{
        font-size: 28px;
        color: #333;
        margin-bottom: 10px;
      }
      span{
        font-size: 24px;
        color: #999
      }
    }
    img{
      position: absolute;
      right: 0;
      bottom: 0;
      width: 154px;
      height: 217px
    }
  }
</style>
